"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parkingPointSelect = exports.serviceProviderSelect = void 0;
const system_1 = __importDefault(require("../api/system"));
const ComplexSelect_1 = __importDefault(require("@/class/ComplexSelect"));
exports.serviceProviderSelect = new ComplexSelect_1.default({
    name: '服务商',
    enable: true,
    list: [],
    getData() {
        return new Promise((resolve, reject) => {
            system_1.default.serviceProviderList.require({
                pageNo: 1,
                pageSize: 1000
            }).then(res => {
                const list = res.data.data.map((item) => {
                    item.value = item.id;
                    item.label = item.serviceName;
                    item.$filter = [item.enableFlag === 1 ? 'enable' : 'disabled'];
                    return item;
                });
                resolve({ status: 'success', list });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
});
exports.parkingPointSelect = new ComplexSelect_1.default({
    name: '停车点',
    enable: true,
    list: [],
    getData() {
        return new Promise((resolve, reject) => {
            system_1.default.parkingPointList.require({
                pageNo: 1,
                pageSize: 1000
            }).then(res => {
                const list = res.data.data.map((item) => {
                    item.value = item.id;
                    item.label = item.parkPointName;
                    item.$filter = [item.status === 1 ? 'enable' : 'disabled'];
                    return item;
                });
                resolve({ status: 'success', list });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
});
